import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconShoppingBag48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="shopping bag">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.6736 13L9.1736 43H38.8264L36.3264 13H11.6736ZM38.1667 11H9.83333L7 45H41L38.1667 11Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 6C16 4.34315 17.3431 3 19 3H29C30.6569 3 32 4.34315 32 6V13H16V6ZM19 5C18.4477 5 18 5.44772 18 6V11H30V6C30 5.44772 29.5523 5 29 5H19Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconShoppingBag24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="shopping bag">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.80052 7L4.22158 22H19.7784L18.1995 7H5.80052ZM20 5H4L2 24H22L20 5Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 2C7 0.89543 7.89543 0 9 0H15C16.1046 0 17 0.895431 17 2V7H7V2ZM15 2H9V5H15V2Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconShoppingBag16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="shopping bag">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.98165 6L3.20387 14H12.7961L12.0183 6H3.98165ZM13.8333 4H2.16667L1 16H15L13.8333 4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4V5C12 5.55228 11.5523 6 11 6H5C4.44772 6 4 5.55228 4 5V4ZM8 2C6.89543 2 6 2.89543 6 4H10C10 2.89543 9.10457 2 8 2Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
